import { render } from "./RecipeSection.vue?vue&type=template&id=10d11109&scoped=true"
import script from "./RecipeSection.vue?vue&type=script&lang=js"
export * from "./RecipeSection.vue?vue&type=script&lang=js"

import "./RecipeSection.vue?vue&type=style&index=0&id=10d11109&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d11109"]])

export default __exports__